import { render, staticRenderFns } from "./RegionesComponent.vue?vue&type=template&id=a08f8c7e"
import script from "./RegionesComponent.vue?vue&type=script&lang=js"
export * from "./RegionesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports